const INITIAL_TABLE_STATE = {
  unsortedData: [],
  sortedData: [],
  expandedIds: [],
  selectedIds: [],
  rowIdKey: '',
  sortKey: '',
  sortType: '',
  sortDirection: '',
  isInitialized: false
};

const TableData = {
  INITIAL_TABLE_STATE
};

export default TableData;